import changeThNumber from "./upandDown";
import changeState from "./changeState";
import getEventId from "./getEventId";
import setSingleEventData from "./EventId";
import {combineReducers} from "redux";
const rootReducers = combineReducers({
    changeState,
    changeThNumber,
    getEventId,
    setSingleEventData
})
export default rootReducers;